import Swiper from "swiper";
import { Navigation, Autoplay, Thumbs } from "swiper/modules";
Swiper.use([Navigation, Autoplay, Thumbs]);

document.querySelectorAll("section.collection-group").forEach((section) => {
	new Swiper(section.querySelector(".collection-swiper"), {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 20,
		grabCursor: true,
		navigation: {
			nextEl: section.querySelector(".swiper-button-next"),
			prevEl: section.querySelector(".swiper-button-prev"),
			injectStyles: false,
		},
		speed: 1600,
		autoplay: {
			delay: 3500,
			pauseOnMouseEnter: true,
			disableOnInteraction: true,
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 20,
			},

			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
});

document.querySelectorAll("section.single-product .product-showcase").forEach((section) => {
	let swiper = new Swiper(section.querySelector(".product-gallery-thumbs"), {
		loop: true,
		slidesPerView: 6,
		spaceBetween: 10,
		watchSlidesProgress: true,
	});
	new Swiper(section.querySelector(".product-gallery"), {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
			injectStyles: false,
		},
		thumbs: {
			swiper: swiper,
		},
	});
});
document.querySelectorAll("section.video-slider").forEach((section) => {
	new Swiper(section.querySelector(".video-slider-wrapper"), {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		grabCursor: true,
		navigation: {
			nextEl: section.querySelector(".swiper-button-next"),
			prevEl: section.querySelector(".swiper-button-prev"),
			injectStyles: false,
		},
		speed: 1600,
		autoplay: {
			delay: 3500,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			},
			1000: {
				slidesPerView: 4,
			},
		},
	});
});
